module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"toolbar":{"title":"Manor-Reparaturen"}},"en":{"toolbar":{"title":"Manor-Repair"}},"fr":{"toolbar":{"title":"Manor-Réparation"}},"it":{"toolbar":{"title":"Manor-Reparazione"}}}')
  delete Component.options._Ctor
}
